export const pinataAPIkey = process.env.REACT_APP_PINATA_API_KEY;
export const pinataAPIsecret = process.env.REACT_APP_PINATA_API_SECRET;
